import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=6f6c558a&scoped=true&"
import script from "./Tree.vue?vue&type=script&lang=ts&"
export * from "./Tree.vue?vue&type=script&lang=ts&"
import style0 from "./Tree.vue?vue&type=style&index=0&id=6f6c558a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6c558a",
  null
  
)

export default component.exports